import { apiClient } from "../lib/apiClient";
import type { GlobalStats } from "../types";

export async function getGlobalStats(): Promise<GlobalStats> {
  const { data } = await apiClient.get<{ stats: GlobalStats }>("/stats");
  return data.stats;
}
